import React, { useState } from "react";
import { toast } from "sonner";
import { LifeBuoy, Send } from "lucide-react";
import api from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";

const CATEGORIES = ["Account", "Payment", "Subscription", "Predictor", "Technical problems"];

export default function Support() {
  const { settings } = useSettings();
  const [category, setCategory] = useState(CATEGORIES[0]);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/support", { category, subject, message });
      toast.success("Your support request has been submitted.");
      setSubject(""); setMessage("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not submit.");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-2xl mx-auto" data-testid="support-page">
      <p className="vw-label">Support</p>
      <h1 className="font-display text-2xl sm:text-3xl font-bold text-white mt-1 mb-2">How can we help?</h1>
      <p className="text-slate-400 mb-6">{settings?.support_info}</p>

      <form onSubmit={submit} className="vw-card p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium text-slate-300 mb-1.5">Category</label>
          <select value={category} onChange={(e) => setCategory(e.target.value)} className="vw-input" data-testid="support-category">
            {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-300 mb-1.5">Subject</label>
          <input value={subject} onChange={(e) => setSubject(e.target.value)} className="vw-input" placeholder="Brief summary" required data-testid="support-subject" />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-300 mb-1.5">Message</label>
          <textarea value={message} onChange={(e) => setMessage(e.target.value)} rows={5} className="vw-input resize-none" placeholder="Describe your issue…" required data-testid="support-message" />
        </div>
        <button disabled={loading} className="vw-btn-primary w-full !py-3.5 inline-flex items-center justify-center gap-2 disabled:opacity-60" data-testid="support-submit">
          {loading ? "Sending…" : <><Send size={18} /> Submit Request</>}
        </button>
      </form>
    </div>
  );
}
